export default "__VITE_ASSET__BFuBcc$0__"